import './style/index.js';

import _Link from './Link';

export type { LinkProps } from './Link';

export const Link = _Link;

export default Link;
